ACC.checkout = {

    _autoload: [
        'initializePiSession',
        'initialize',
        'bindCheckO',
        'bindForms',
        'bindSavedPayments',
        'bindPaymentTypeSelect',
        'bindAccountVerificationTypeSelect',
        'bindDeliveryMethodChange', ['bindCardTypeIdentification', $('#card_accountNumber').length !== 0],
        ['bindContactPhoneValidation', $('#contactPhone').length !== 0],
        ['scrollToInlineAddressDoctor', document.querySelector('.inline-address-doctor')],
        ['bindReenterAddressButton', document.querySelector('.js-btn-reenter-address')],
        ['bindSaveInAddressBook',
            document.getElementById('saveInAddressBook') && document.getElementById('saveAddressInMyAddressBook')],
    ],

    piSessionData: {},

    bindForms() {
        $(document).on('click', '#addressSubmit', (e) => {
            e.preventDefault();
            const addressTypeInput = $('input[type=radio][name=addressType]');
            if (addressTypeInput.length > 0) {
                const checkedButton = addressTypeInput.filter(':checked').val();
                if (checkedButton === 'oneAddress') {
                    ACC.checkout.handleAddressForm('#selectAddressForm');
                } else if (checkedButton === 'searchAddress') {
                    ACC.checkout.handleAddressForm('#searchAddressForm');
                } else if (checkedButton === 'addNewAddress') {
                    ACC.checkout.validateAndSubmitAddressForm();
                }
            } else {
                ACC.checkout.validateAndSubmitAddressForm();
            }
        });

        $(document).on('click', '#deliveryMethodSubmit', (e) => {
            e.preventDefault();
            $('#selectDeliveryMethodForm').submit();
        });

        $(document).on('click', '#qualificationUsersSubmit', (e) => {
            e.preventDefault();
            $('#qualifiedUsersForm').submit();
        });

        $(document).on('click', '#paymentTypeSubmit', (e) => {
            e.preventDefault();
            $('#selectPaymentTypeForm').submit();
        });

        $(document).on('click', '#accountVerificationSubmit', (e) => {
            e.preventDefault();
            $('#accountVerificationForm').submit();
        });

        $(document).on('click', '#toggleQualifiedUserAddEmail', (e) => {
            e.preventDefault();
            $('.checkoutQualifiedUserAddEmailSection').toggle();
            $('#toggleQualifiedUserAddEmail > span').toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
        });

        // eslint-disable-next-line max-len
        if ($('.checkoutQualifiedUserAddEmailSection') && $('.checkoutQualifiedUserAddEmailSection >.form-group').hasClass('has-error')) {
            $('.checkoutQualifiedUserAddEmailSection').show();
        }
    },

    validateAndSubmitAddressForm() {
        ACC.checkout.scrollToFirstInvalidField();
        ACC.checkout.handleAddressForm('#addressForm');
    },

    handleAddressForm(selector) {
        ACC.checkout.trimFormInputValues(selector);
        $(selector).submit();
    },

    trimFormInputValues(selector) {
        const inputs = document.querySelectorAll(`${selector} input`);
        inputs.forEach((input) => {
            input.value = input.value.trim();
        });
    },

    processCheckoutRequest(targetUrl, updateCustomerUrl) {
        $.post({
            url: updateCustomerUrl,
            data: ACC.checkout.piSessionData,
            // eslint-disable-next-line no-unused-vars
            success(res) {
                window.location = targetUrl;
            },
            // eslint-disable-next-line no-unused-vars
            error(jqXHR, exception) {
                const localizedBusinessError = $('#callIAMErrorMsg').val();
                $('.global-alerts').addClass('alert-danger');
                $('.alert-message').html(ACC.common.encodeHtml(localizedBusinessError));
            },
        });
    },

    bindSavedPayments() {
        $(document).on('click', '.js-saved-payments', (e) => {
            e.preventDefault();

            const title = $('#savedpaymentstitle').html();

            $.colorbox({
                href: '#savedpaymentsbody',
                inline: true,
                opacity: 0.7,
                title,
                close: '<span class="glyphicon glyphicon-remove"></span>',
                onComplete() {},
            });
        });
    },

    bindCheckO() {
        // eslint-disable-next-line no-unused-vars
        const cartEntriesError = false;

        // Alternative checkout flows options
        $('.doFlowSelectedChange').change(() => {
            // eslint-disable-next-line eqeqeq
            if ($('#selectAltCheckoutFlow').val() == 'multistep-pci') {
                $('#selectPciOption').show();
            } else {
                $('#selectPciOption').hide();
            }
        });

        $('.expressCheckoutButton').click(() => {
            document.getElementById('expressCheckoutCheckbox').checked = true;
        });

        $(document).on('input', '.confirmGuestEmail,.guestEmail', () => {
            const orginalEmail = $('.guestEmail').val();
            const confirmationEmail = $('.confirmGuestEmail').val();

            if (orginalEmail === confirmationEmail) {
                $('.guestCheckoutBtn').removeAttr('disabled');
            } else {
                $('.guestCheckoutBtn').attr('disabled', 'disabled');
            }
        });

        $('.js-continue-checkout-button').click(function (event) {
            event.preventDefault();
            const targetUrl = $(this).data('target-url');
            const updateCustomerUrl = $(this).data('update-customer-url');
            ACC.checkout.processCheckoutRequest(targetUrl, updateCustomerUrl);
        });
    },

    redirectToCheckoutPage(checkoutUrl) {
        // eslint-disable-next-line no-undef
        cartEntriesError = ACC.pickupinstore.validatePickupinStoreCartEntires();
        // eslint-disable-next-line no-undef
        if (!cartEntriesError) {
            const expressCheckoutObject = $('.express-checkout-checkbox');
            if (expressCheckoutObject.is(':checked')) {
                window.location = expressCheckoutObject.data('expressCheckoutUrl');
            } else {
                let flow = $('#selectAltCheckoutFlow').val();
                // eslint-disable-next-line eqeqeq
                if (flow == undefined || flow == '' || flow == 'select-checkout') {
                    // No alternate flow specified, fallback to default behaviour
                    window.location = checkoutUrl;
                } else {
                    // Fix multistep-pci flow
                    // eslint-disable-next-line eqeqeq
                    if (flow == 'multistep-pci') {
                        flow = 'multistep';
                    }
                    const pci = $('#selectPciOption').val();

                    // Build up the redirect URL
                    const redirectUrl = `${checkoutUrl}/select-flow?flow=${flow}&pci=${pci}`;
                    window.location = redirectUrl;
                }
            }
        }
    },

    bindPaymentTypeSelect() {
        $("input:radio[name='paymentType']").change(() => {
            if (ACC.checkout.isAccountPayment()) {
                ACC.checkout.displayAccountPaymentSection(true);
            } else {
                ACC.checkout.displayAccountPaymentSection(false);
            }
            ACC.checkout.initialize();
        });
    },

    bindAccountVerificationTypeSelect() {
        const $checkboxes = $('[name="verificationType"]');
        const $submitBtn = $('#accountVerificationSubmit');

        function updateState() {
            if ($checkboxes.filter(':checked').length > 0) {
                $submitBtn.prop('disabled', false);
            } else {
                $submitBtn.prop('disabled', true);
            }
        }

        updateState();
        $checkboxes.on('change', updateState);
    },

    isNewAccount() {
        return $('input:radio[name=verificationType]:checked').val() === 'NewAccount';
    },

    initialize() {
        if (ACC.checkout.isAccountPayment()) {
            ACC.checkout.displayAccountPaymentSection(true);
        } else {
            ACC.checkout.displayAccountPaymentSection(false);
        }
    },

    initializePiSession() {
        if (!piSession) { return; }

        ACC.piSessionInitializer.addCallback(() => {
            piSession.getToken((status, token) => {
                // eslint-disable-next-line dot-notation
                ACC.checkout.piSessionData['userID'] = piSession.userId();
                // eslint-disable-next-line dot-notation
                ACC.checkout.piSessionData['token'] = token;
            });
        });
    },

    isAccountPayment() {
        // eslint-disable-next-line eqeqeq
        return $("input:radio[name='paymentType']:checked").val() == 'ACCOUNT';
    },

    displayAccountPaymentSection(data) {
        ACC.checkout.displayElement($('#accountPaymentDivID'), data);
    },

    displayElement(element, flag) {
        if (flag) {
            element.show();
        } else {
            element.hide();
        }
    },

    bindCardTypeIdentification() {
        const $creditsBox = $('.js-credits-box');
        const cardTypeToCardTypeCodeMap = {
            visa: '001',
            mastercard: '002',
            amex: '003',
            discover: '004',
        };

        // eslint-disable-next-line no-new,no-undef
        new Cleave('#card_accountNumber', {
            creditCard: true,
            onCreditCardTypeChanged(type) {
                const value = cardTypeToCardTypeCodeMap[type] || 'invalid';
                $('#card_cardType').val(value);

                $creditsBox.find('.card-logo').addClass('isDisabled');
                if (value !== 'invalid') {
                    $creditsBox.find(`[data-type="${type}"]`).removeClass('isDisabled');
                }
            },
        });
    },

    bindContactPhoneValidation() {
        function validateContactPhone() {
            if (ACC.config.isIntlTelInputEnabled) {
                // eslint-disable-next-line no-use-before-define
                changeButtonView(!$('#phone\\.errors').length && $('#contactPhone').val());
            } else {
                const contactPhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                // eslint-disable-next-line no-use-before-define
                changeButtonView(contactPhoneRegex.test($('#contactPhone').val()));
            }
        }

        function changeButtonView(isValidContactPhone) {
            if (isValidContactPhone) {
                $('#contactPhoneSubmit').prop('disabled', false);
            } else {
                $('#contactPhoneSubmit').prop('disabled', true);
            }
        }

        $('#contactPhone').on('change', validateContactPhone);
        validateContactPhone();
    },

    bindDeliveryMethodChange() {
        function showMessagesFromDropDown() {
            const deliveryMethod = document.querySelector('#delivery_method');

            if (!deliveryMethod) {
                return;
            }

            const { onDemandEnabled, onDemandFreeOfChargeText, onDemandChargeableText } = ACC.config;
            const selectedDeliveryOption = deliveryMethod.options[deliveryMethod.selectedIndex];
            const dataEstimatedMessage = selectedDeliveryOption.getAttribute('data-estimated-message');
            const dataDeliveryMessage = selectedDeliveryOption.getAttribute('data-delivery-message');
            const freeDeliveryMethodChosen = deliveryMethod.value.includes('_ground_delivery');
            const estimatedDeliveryTimeMessage = document.querySelector('#estimatedDeliveryTime');
            const aodProduct = document.querySelector('.product-info__available-on-demand');
            const estimatedDeliveryDescription = document.querySelector('#estimatedDeliveryDescription');
            const deliveryDescription = document.querySelector('#deliveryDescription');

            if (!onDemandEnabled || !freeDeliveryMethodChosen || !aodProduct) {
                estimatedDeliveryDescription.innerHTML = dataEstimatedMessage;
                deliveryDescription.innerHTML = dataDeliveryMessage;
            } else if (estimatedDeliveryDescription && deliveryDescription) {
                estimatedDeliveryDescription.innerText = '';
                deliveryDescription.innerText = '';
            }

            if (!onDemandEnabled || !aodProduct || !estimatedDeliveryTimeMessage) {
                return;
            }

            if (freeDeliveryMethodChosen) {
                estimatedDeliveryTimeMessage.innerText = onDemandFreeOfChargeText;
            } else {
                estimatedDeliveryTimeMessage.innerText = onDemandChargeableText;
            }
        }

        function showMessagesFromRadioBtn() {
            // eslint-disable-next-line max-len
            $('#estimatedDeliveryDescription').html($("input[name='delivery_method']:checked").data('estimated-message'));
            $('#deliveryDescription').html($("input[name='delivery_method']:checked").data('delivery-message'));
        }
        $('#delivery_method').change(showMessagesFromDropDown);
        $('#selectDeliveryMethodForm input').on('change', showMessagesFromRadioBtn);
        showMessagesFromDropDown();
        showMessagesFromRadioBtn();
    },

    scrollToFirstInvalidField() {
        const errorElements = $('.has-error');
        const errorVisible = $('.has-error').is(':visible');
        if (errorElements.length && errorVisible) {
            $('html, body').animate({
                scrollTop: $(errorElements[0]).offset().top,
            }, 500);
        }
    },

    scrollToInlineAddressDoctor() {
        window.onload = () => {
            const inlineAddressDoctor = document.querySelector('.inline-address-doctor');

            if (!inlineAddressDoctor.classList.contains('hidden')) {
                inlineAddressDoctor.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        };
    },

    bindReenterAddressButton() {
        const reenterAddressBtn = document.querySelector('.js-btn-reenter-address');
        const inlineAddressDoctor = document.querySelector('.inline-address-doctor');
        const form = document.querySelector('#addressForm');

        reenterAddressBtn.addEventListener('click', (e) => {
            e.preventDefault();
            form.scrollIntoView({
                behavior: 'smooth',
            });
            inlineAddressDoctor.remove();
        });
    },

    bindSaveInAddressBook() {
        const saveAddressInMyAddressBook = document.getElementById('saveAddressInMyAddressBook');
        const hiddenSaveInAddressBook = document.querySelectorAll('#saveInAddressBook');

        saveAddressInMyAddressBook.addEventListener('change', (e) => {
            // eslint-disable-next-line no-return-assign
            [...hiddenSaveInAddressBook].forEach((item) => item.value = e.target.checked);
        });
    },
};
